import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { selectInvolvementTypes } from 'redux/selectors/people';
import {
  addMember, addAIMember, getInvolvementTypes, addHub71Employee,
} from 'redux/actions/people';
import { StateType } from 'types';
import { selectNationalities, selectStartups, selectAngelInvestors } from 'redux/selectors/workspace';
import { getNationalities, getStartups, getAngelInvestors } from 'redux/actions/workspace';

const mapStateToProps = (state: StateType) => ({
  startups: selectStartups(state),
  angelInvestors: selectAngelInvestors(state),
  involvementTypes: selectInvolvementTypes(state),
  nationalities: selectNationalities(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    addMember,
    addAIMember,
    getStartups,
    getAngelInvestors,
    addHub71Employee,
    getInvolvementTypes,
    getNationalities,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
